import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function indexSkills(): Promise<ApiResponse> {
  return Axios.get("/v1/candidates/skills");
}
